import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRemoteUICopy } from '../copy.js';
function status(item) {
    if (item.status)
        return item.status;
    return item.completed ? 'completed' : 'pending';
}
export function TodoItem({ item }) {
    const copy = useRemoteUICopy();
    return _jsxs("article", { className: "agent-timeline-item agent-todo", children: [_jsxs("header", { className: "agent-item-header", children: [_jsx("span", { className: "agent-item-kicker", children: copy.taskBoard }), _jsx("strong", { children: copy.executionPlan })] }), _jsx("ol", { children: item.items.map((task, index) => {
                    const current = status(task);
                    return _jsxs("li", { className: `agent-state-${current}`, children: [_jsx("span", { className: "agent-todo-mark", "aria-hidden": "true", children: current === 'completed' ? '✓' : current === 'in_progress' ? '→' : '·' }), _jsx("span", { children: task.text }), _jsx("small", { children: copy.status(current) })] }, task.id ?? `${task.text}-${index}`);
                }) })] });
}
//# sourceMappingURL=TodoItem.js.map